// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.hello {\r\n    text-align: left;\r\n    padding-bottom: 40px;\r\n    font-style: italic;\r\n    color: grey;\n}\n.widget {\r\n    border: solid;\r\n    border-color: #dee2e6;\r\n    border-width: 1px;\r\n    margin-bottom: 40px;\n}\n.icon {\r\n    margin-bottom: 15px;\r\n    margin-right: 3px;\r\n    height: 30px;\r\n    width: 30px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
